import { UsersRound, ClipboardCheck, MessagesSquare, GraduationCap } from 'lucide-react';

import Container from '../../Main/sections/Container';
import Reveal from '../../../components/Reveal';

const AUDIENCES = [
  {
    icon: UsersRound,
    color: '#5ED8B2',
    title: 'Study Groups',
    body: 'Build one shared set of notes across the whole group. Everyone contributes — divide topics, merge notes, study together.',
  },
  {
    icon: ClipboardCheck,
    color: '#a78bfa',
    title: 'Exam Prep',
    body: 'Run live group quizzes from your shared notes. Compete on scores, flag weak topics, and revise together the night before.',
  },
  {
    icon: MessagesSquare,
    color: '#f472b6',
    title: 'Study Buddies',
    body: "Annotate and comment directly on a peer's notes — explain concepts in the margin and answer each other's questions in real time.",
  },
  {
    icon: GraduationCap,
    color: '#fb923c',
    title: 'Seminar Groups',
    body: 'Bring a whole class into one workspace. Assign sections, discuss in threads, and build a shared master resource everyone relies on.',
  },
];

const WhoItsFor = () => {
  return (
    <section className="relative py-20 lg:py-24">
      <Container>
        <Reveal className="text-center">
          <span className="eyebrow">Who It&apos;s For</span>
          <h2 className="font-heading mx-auto mt-5 max-w-3xl text-[2rem] font-bold leading-[1.1] sm:text-[2.6rem] lg:text-[3rem]">
            <span className="head-fade">Built For Every Way </span>
            <span className="text-accent-grad">Students Study Together</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[0.95rem] text-white/55">
            Whether it&apos;s a 2-person study buddy or a full seminar group,
            Collaborative Mode has you covered.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {AUDIENCES.map((a, i) => (
            <Reveal key={a.title} delay={i * 90}>
              <div className="glass glass-hover h-full rounded-2xl p-6 text-center">
                <span
                  className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl"
                  style={{ background: `${a.color}1f`, color: a.color }}
                >
                  <a.icon size={22} />
                </span>
                <h3 className="font-heading mt-5 text-[1.15rem] font-semibold text-white">
                  {a.title}
                </h3>
                <p className="mt-2 text-[0.86rem] leading-relaxed text-white/55">
                  {a.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WhoItsFor;
